"use client"

import { useCartStorage } from "@lib/hooks/use-cart-storage"
import SummaryEmpty from "./summary-empty"
import SummaryElement from "./summary-element"
import { useState } from "react"
import OrderButton from "./components/order-button"
import PopupSendOrder from "../popups/popup-send-order"
import { useRouter } from "next/navigation"
import PopupSendOrderSuccess from "../popups/popup-send-order-success"
import PopupSendOrderError from "../popups/popup-send-order-error"
import { createAndCompleteCart } from "@lib/util/cart-utils"
import { useDeliverySelector } from "@lib/hooks/use-delivery-select"
import { useCustomerOrderNum } from "@lib/hooks/use-custom-order-num"
import { sendEmail, sendEmailFromTemplate } from "@lib/util/email-utils"
import { Customer } from "@medusajs/medusa"
import { orderSendTemplate } from "@lib/util/email-templates"
import { useCustomNote } from "@lib/hooks/use-custom-note"

const CartSummary = (props: { customer: Customer | undefined }) => {
  const cartStorage = useCartStorage()
  const router = useRouter()
  const deliverySelector = useDeliverySelector()
  const customOrderNum = useCustomerOrderNum()
  const customNote = useCustomNote()

  const [orderPopupVisibility, setOrderPopupVisibility] = useState(false)
  const [orderPopupVisibilitySuccess, setOrderPopupVisibilitySuccess] =
    useState(false)
  const [orderPopupVisibilityError, setOrderPopupVisibilityError] =
    useState(false)

  const [orderApproved, setOrderApproved] = useState(false)

  const handleOrderButtonClick = () => {
    setOrderPopupVisibility(true)
    window.scrollTo(0, 0)
  }

  const handlePopupClick = (accepted: boolean) => {
    if (accepted) {
      setOrderApproved(true)
      createAndCompleteCart({
        items: cartStorage.items,
        selectedAddress: deliverySelector.address,
        customOrderNum: customOrderNum.orderNum,
        customNote: customNote.customNote,
      }).then((createOrderResult) => {
        if (createOrderResult.success) {
          setOrderPopupVisibility(false)
          setOrderPopupVisibilitySuccess(true)
          cartStorage.clearCart()
          customOrderNum.customOrderChange("")
          customNote.customNoteChange("")
          setInterval(() => {
            setOrderPopupVisibilitySuccess(false)
            router.push(`/thank-you?order=${createOrderResult.orderID}`)
          }, 3000)
        } else {
          // Error occured
          setOrderPopupVisibility(false)
          setOrderPopupVisibilityError(true)
          setOrderApproved(false)
          setInterval(() => {
            setOrderPopupVisibilityError(false)
          }, 5000)
        }
      })
    } else {
      setOrderApproved(false)
      setOrderPopupVisibility(false)
    }
  }

  return (
    <div className="flex flex-col items-center justify-start w-full min-h-[8rem] xl:max-w-md max-w-5xl bg-[#FAFAF5] border border-[#E6E6E6] rounded-2xl p-3">
      <h1 className="w-full text-center pb-2 text-lg font-medium border-b border-[#E6E6E6]">
        Souhrn objednávky
      </h1>
      <div className="w-full h-full pt-3">
        {cartStorage?.items?.length === 0 && <SummaryEmpty />}
        {cartStorage?.items?.length > 0 && (
          <>
            <table className="w-full table-fixed">
              <tbody>
                {cartStorage?.items?.map((item, index) => {
                  return (
                    <SummaryElement
                      key={index}
                      code={item.productCode}
                      title={item.productTitle}
                      value={item.count}
                      unit={item.unit}
                    />
                  )
                })}
              </tbody>
            </table>
            <OrderButton onClick={handleOrderButtonClick} />
          </>
        )}
      </div>
      <PopupSendOrder
        visibility={orderPopupVisibility}
        loadingVisibility={orderApproved}
        onPositiveClick={() => handlePopupClick(true)}
        onNegativeClick={() => handlePopupClick(false)}
      />
      <PopupSendOrderSuccess visibility={orderPopupVisibilitySuccess} />
      <PopupSendOrderError visibility={orderPopupVisibilityError} />
    </div>
  )
}

export default CartSummary
